<template>
    <index-table-row :item="item">
        <index-table-cell v-text="item.name"/>
        <index-table-cell v-text="item.reseller"/>
        <index-table-cell-bool :bool="Boolean(item.compliance_active)"/>
        <index-table-cell-bool :bool="Boolean(item.dfs_active)"/>
        <index-table-cell-bool :bool="Boolean(item.academy_active)"/>
        <index-table-cell-date :date="String(this.item.deletedAt)"/>
        <index-table-cell>
            <organization-deleted-more-dropdown :organization="itemData"/>
        </index-table-cell>
    </index-table-row>
</template>

<script>
    import IndexTableRow from "../../../components/Index/IndexTableRow";
    import IndexTableCell from "../../../components/Index/IndexTableCell";
    import OrganizationDeletedMoreDropdown from "./OrganizationDeletedMoreDropdown";
    import IndexTableCellBool from "../../../components/Index/IndexTableCellBool";
    import IndexTableCellDate from "../../../components/Index/IndexTableCellDate";

    export default {
        name: "OrganizationDeletedRow",
        components: {
            IndexTableCellDate,
            IndexTableCellBool, OrganizationDeletedMoreDropdown, IndexTableCell, IndexTableRow},
        props: {
            item: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                itemData: this.item,
            }
        },
        watch: {
            item(value) {
                this.itemData = value;
            }
        },
    }
</script>